<template>
    <div :key="current.title" class="w-100 h-100 d-flex flex-column justify-content-center">
        <h3 v-show="current.title"
            class="text-uppercase mb-5 font-family-alternative nav__modal-title"
        >
            {{ current.title }}
        </h3>
        <div class="container-fluid">
            <div class="row">
                <div class="col-12 col-md-10 col-lg-9 col-xl-8">
                    <div class="row" ref="listContainer">
                        <div class="col-12 col-md-5">
                            <div v-for="element in left"
                                 class="secondary-text nav__link"
                                 :class="{ huge: element.huge }"
                            >
                                <app-link :href="element.url || '#'"
                                          :child="element.child"
                                          @click="navigate(element, $event)"
                                >
                                    {{ element.name }}
                                </app-link>
                            </div>
                        </div>
                        <div class="col-12 col-md-5 offset-md-2">
                            <div v-for="element in right"
                                 class="secondary-text nav__link"
                                 :class="{ huge: element.huge }"
                            >
                                <app-link :href="element.url || '#'"
                                          :child="element.child"
                                          @click="navigate(element, $event)"
                                >
                                    {{ element.name }}
                                </app-link>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    import jQuery from 'jquery';

    export default {
        name: 'app-nav-list',
        props: [ 'current' ],
        watch: {
            current () {
                setTimeout(this.focusLastFocused.bind(this));
            },
        },
        data () {
            return {
                nextLastFocused: 0,
                lastFocused: 0,
            };
        },
        methods: {
            navigate (element, event) {
                if (element.child) {
                    event.preventDefault();
                    this.$emit('navigate', element);
                }
                this.nextLastFocused = jQuery(this.$refs.listContainer).find('.button-link').index(document.activeElement);
            },
            focusLastFocused () {
                jQuery(this.$refs.listContainer).find('.button-link').get(this.lastFocused).focus();
                this.lastFocused     = this.nextLastFocused;
                this.nextLastFocused = 0;
            },
        },
        computed: {
            left () {
                return this.current.elements.slice(0, Math.ceil(this.current.elements.length / 2));
            },
            right () {
                return this.current.elements.slice(Math.ceil(this.current.elements.length / 2));
            },
        },
    };
</script>
